var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import get from 'lodash-es/get';
import isNil from 'lodash-es/isNil';
import React from 'react';
export const withFormikSupport = (Component) => function (_a) {
    var { invalid = false, error, field, form, onChange, onBlur } = _a, other = __rest(_a, ["invalid", "error", "field", "form", "onChange", "onBlur"]);
    const formikTouched = field && form && get(form.touched, field.name);
    const formikError = field && form && get(form.errors, field.name);
    const getValue = (eventOrValue) => {
        var _a, _b, _c, _d, _e;
        if (((_a = eventOrValue === null || eventOrValue === void 0 ? void 0 : eventOrValue.target) === null || _a === void 0 ? void 0 : _a.type) === 'checkbox') {
            return !isNil((_b = eventOrValue === null || eventOrValue === void 0 ? void 0 : eventOrValue.target) === null || _b === void 0 ? void 0 : _b.checked) ? (_c = eventOrValue === null || eventOrValue === void 0 ? void 0 : eventOrValue.target) === null || _c === void 0 ? void 0 : _c.checked : eventOrValue;
        }
        return !isNil((_d = eventOrValue === null || eventOrValue === void 0 ? void 0 : eventOrValue.target) === null || _d === void 0 ? void 0 : _d.value) ? (_e = eventOrValue === null || eventOrValue === void 0 ? void 0 : eventOrValue.target) === null || _e === void 0 ? void 0 : _e.value : eventOrValue;
    };
    const handleChange = (newValue) => {
        if (form && field) {
            form.setFieldValue(field.name, getValue(newValue));
        }
        if (onChange) {
            return onChange(newValue);
        }
        return null;
    };
    const handleBlur = (e) => {
        if (onBlur) {
            onBlur(e);
        }
        if (form && field) {
            form.setFieldTouched(field.name, true);
        }
    };
    return (React.createElement(Component, Object.assign({}, other, field, { invalid: invalid || error || ((formikTouched || (form === null || form === void 0 ? void 0 : form.submitCount)) && !!formikError), error: error || ((formikTouched || (form === null || form === void 0 ? void 0 : form.submitCount)) && formikError), onChange: handleChange, onBlur: handleBlur })));
};
//# sourceMappingURL=withFormikSupport.js.map